module.exports = __webpack_public_path__ + "img/user_w.4cf87111.svg";